'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('./loading.scss');

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 默认的 loading 实现
 */

var loadingId = 'miHoYoEventModelLoading';

// 生成html
if ($('#' + loadingId).length === 0) {
  $(document.body).append(template.render(require('./loading.tpl'), { loadingId: loadingId }));
}

/**
 * 显示loading
 */
var show = function show() {
  window.clearTimeout(_store2.default.get('hideEventModelLoadingTimer'));
  if (!_store2.default.get('isEventModelRequesting')) {
    _store2.default.set('isEventModelRequesting', true);
    $('#' + loadingId).show(150);
  }
};

/**
 * 隐藏loading
 */
var hide = function hide() {
  var hideLoadingTimer = window.setTimeout(function () {
    _store2.default.set('isEventModelRequesting', false);
    $('#' + loadingId).hide();
  }, 300);

  _store2.default.set('hideEventModelLoadingTimer', hideLoadingTimer);
};

exports.default = {
  show: show,
  hide: hide
};